const allCollections = {
  users: "users",
  drivingCourse: "drivingCourse",
  drivingLessons: "drivingLessons",
  billing: "billing",
  regions: "regions",
  users_regions: "users_regions",
  courseCategory: "courseCategory",
  courseClass: "courseClass",
  prices: "prices",
  scheduleCourses: "scheduleCourses",
  instructorSurvey: "instructorSurvey",
  starHistory: "starHistory",
};

export const USER_REGIONS_COLLECTION = allCollections.users_regions;
export const REGIONS_COLLECTION = allCollections.regions;
export const USER_COLLECTION = allCollections.users;
export const DRIVING_COURSE_COLLECTION = allCollections.drivingCourse;
export const DRIVING_LESSON_COLLECTION = allCollections.drivingLessons;
export const BILLING_COLLECTION = allCollections.billing;
export const COURSE_CATEGORY_COLLECTION = allCollections.courseCategory;
export const PRICES_COLLECTION = allCollections.prices;
export const COURSE_CLASS_COLLECTION = allCollections.courseClass;
export const SCHEDULE_COURSES_COLLECTION = allCollections.scheduleCourses;
export const INSTRUCTOR_SURVEY_COLLECTION = allCollections.instructorSurvey;
export const STAR_HISTORY_COLLECTION = allCollections.starHistory;
